import { LinkColors, MyLink } from '@app/shared';
import { pathToBrandCatalog } from '@app/shared/helpers';
import { useAppSelector } from '@redux/hooks';
import classNames from 'classnames';
import groupBy from 'lodash/groupBy';
import { FC, useMemo } from 'react';
import { sortBrandName } from '../../module/helpers/sortBrand';
import { BrandListAlphabetTypeProps } from './TypeProps';

import styles from './BrandListAlphabet.module.scss';

export const BrandListAlphabet: FC<BrandListAlphabetTypeProps> = ({ className, brands, type }) => {
  const host = useAppSelector(state => state.header.data.host);
  const list = useMemo(() => {
    const sortBrands = [...brands]?.sort(sortBrandName);
    return groupBy(sortBrands, i => i?.name?.slice(0, 1)?.toUpperCase());
  }, []);
  return (
    <div className={classNames(styles.WrapperBrandListAlphabet, className)}>
      {Object.entries(list)?.map(([title, items]) => (
        <div className={styles.Container} key={title}>
          <div className={styles.Title}>{title}</div>
          <div className={styles.Items}>
            {items?.map(brand => {
              const path = pathToBrandCatalog(type, brand?.urlname);
              return (
                <MyLink reloaded color={LinkColors.Black} key={brand?.urlname} href={`${host}${path}`} data-testid={`brand-alpha-${path}`}>
                  {brand?.name}
                </MyLink>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
